import styled from "styled-components";
import { size } from "../../style/util/size";
import { device } from "../../style/util/media-query";
import {
  GlascLogoHeightLarge,
  GlascLogoHeightSmall,
  GlascLogoPadding,
} from "../general/GlascLogo/GlascLogo.styled";

export const StyledBaseSection = styled.section`
  ${size("100%", "auto")};
  position: relative;
  display: flex;
  top: 0;
  min-height: 100%;
  padding: 10rem ${({ theme }) => theme.sitePaddingHorizontal}
    calc((${GlascLogoHeightSmall} + ${GlascLogoPadding}));
  overflow-x: hidden;

  @media ${device.desktop} {
    align-items: center;
  }

  @media ${device.desktopL} {
    padding-bottom: calc((${GlascLogoHeightLarge} + ${GlascLogoPadding}));
  }
`;

export const StyledBaseSectionInner = styled.div`
  ${size("90%", "auto")};
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.sectionInnerMaxWidth};

  @media ${device.desktop} {
    width: 100%;
  }
`;

export const StyledContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;
